import $$ from "cmn-utils";
import modelEnhance from "@/utils/modelEnhance";
import * as api from "../services";
import { routerRedux } from "dva/router";
import http from "@/http";
import { clientVersion } from "@/utils/constant";
import intl from "react-intl-universal";
import { message } from "antd";
import menupng from "@/assets/images/menu";
import Purview from "@/components/Purview";
import { LoginUnit } from "@/utils/login-unit";

export default modelEnhance({
  namespace: "global",
  state: {
    version: {
      server: "",
      client: clientVersion,
    },
    user: {},
    menu: [],
    flatMenu: [],
    unit: {},
    unReadCount: {},
    menuList: [],
    websockState: false,
  },
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname }) => {
        dispatch({ type: "getServerVersion" });
        if (pathname.indexOf("account" === -1)) {
          const store = {
            headers: $$.getStore("headers"),
            accessToken: $$.getStore("accessToken"),
            position: $$.getStore("position"),
            weather: $$.getStore("weather"),
          };
          Object.keys(store).forEach((key) => {
            if (!store[key]) {
              console.error("store " + key + " is null now");
            }
          });
        } else {
        }
      });
    },
  },

  effects: {
    *websockStateChange({ payload }, { call, put }) {
      let websockState = payload;
      yield put({ type: "commonSuccess", payload: { websockState } });
    },
    *getServerVersion({ payload }, { call, put }) {
      const ret = yield call(http.tokiot.other.version, {});
      if (ret) {
        yield put({
          type: "commonSuccess",
          payload: {
            version: {
              server: ret.version,
              client: clientVersion,
            },
          },
        });
      }
    },
    *getUserInfo({ payload }, { call, put }) {
      let resolve = payload ? payload.resolve : undefined;
      const ret = yield call(api.getUserInfo, {});
      if (ret) {
        const {
          username,
          role,
          email,
          tel,
          unit,
          id,
          realName,
          avatar,
          permissionCodeList,
          area,
        } = ret;
        const user = {
          userInfo: { username, realName, id, tel, email, avatar },
          unit,
          role,
          unitType: unit.type,
          area,
          isGrid: role.code === `GOV_GRID` || role.code === `GOV_GRID_MAN`,
        };
        let unitList = [];
        if (unit && unit.id && unit.id.length > 0 && user.isGrid) {
          let grid = yield call(http.tokiot.grid.getDistribute, {
            unitId: unit.id,
          });
          if (grid && grid.gridList && grid.gridList.length > 0) {
            let gridItem = grid.gridList.find((f1) => {
              let user = {};
              if (f1.gridUserList && f1.gridUserList.length > 0) {
                user = f1.gridUserList.find(
                  (gridUser) =>
                    gridUser && gridUser.user && gridUser.user.id === id
                );
              }
              return user && user.id && user.id.length > 0;
            });
            if (
              gridItem &&
              gridItem.gridUnitList &&
              gridItem.gridUnitList.length > 0
            ) {
              unitList = gridItem.gridUnitList.map((f1) => f1.unit);
            }
          }
        }
        user.unitList = unitList;
        $$.setStore("user", user);
        yield put({ type: "commonSuccess", payload: { user } });
        yield put({
          type: "loadMenuList",
          user,
          permissions: permissionCodeList,
        });
        $$.setStore("permissions", permissionCodeList);
        resolve && resolve(ret);
      }
    },
    *loadMenuList({ user, permissions }, { call, put }) {
      const menuList = [
        {
          id: "1",
          name: "运维机构",
          target: "overview",
          to: "organs",
          img: menupng.organs,
          icon: "changgui-xitongyunweibumen",
          show: Purview({ action: [`UNIT_SHOW`] }),
        },
        {
          id: "2",
          name: "社会单位",
          target: "overview",
          to: "unit",
          img: menupng.unit,
          icon: "changgui-danwei",
          show: Purview({ action: [`UNIT_SHOW`] }),
        },
        {
          id: "3",
          name: "用户管理",
          target: "overview",
          to: "user",
          img: menupng.user,
          icon: "menu-user-management",
          show: Purview({ action: [`USER_SHOW`] }),
        },
        {
          id: "4",
          name: "设备管理",
          target: "overview",
          to: "device",
          img: menupng.device,
          icon: "product-xianshiqi",
          show: Purview({ action: [`DEVICE_SHOW`] }),
        },
        {
          id: "5",
          name: "告警记录",
          target: "overview",
          to: "alarm",
          img: menupng.alarm,
          icon: "changgui-gaojing",
          show: Purview({ action: [`ALARM_SHOW`] }),
        },
        {
          id: "6",
          name: "事件记录",
          target: "overview",
          to: "event",
          img: menupng.event,
          icon: "changgui-rizhi",
          show: false,
        },
        {
          id: "7",
          name: "隐患排查",
          target: "overview",
          to: "yinhuanpaicha",
          img: menupng.yinhuanpaicha,
          icon: "changgui-daibanshijian",
          show: Purview({ action: [`SAFETY_DANGER_SHOW`] }),
        },
        {
          id: "8",
          name: "安全打卡",
          target: "overview",
          to: "securityCheck",
          img: menupng.anquandaka,
          icon: "changgui-icon_daohang_daka",
          show: Purview({
            action: [
              `SAFETY_TASK_SHOW`,
              `SAFETY_SCHEDULER_SHOW`,
              `SAFETY_POSITION_SHOW`,
            ],
          }),
        },
        {
          id: "9",
          name: "现场勘察",
          target: "overview",
          to: "xianchangkancha",
          img: menupng.xianchangkancha,
          icon: "changgui-xianchangkancha",
          show: Purview({
            action: [`PROSPECT_TASK_SHOW`, `PROSPECT_TEMPLATE_SHOW`],
          }),
        },
        {
          id: "10",
          name: "智能分析",
          target: "overview",
          to: "fenxi",
          img: menupng.statistics,
          icon: "changgui-fenxizhongxin",
          show: Purview({ action: [`DEVICE_ACTION`] }),
        },
        {
          id: "12",
          name: "安全台账",
          target: "overview",
          to: "anquantaizhang",
          img: menupng.SafetyRecord,
          icon: "changgui-yutaizhang",
          show: Purview({
            action: [
              `GRID_DISTRIBUTE_SHOW`,
              `GRID_POSITION_SHOW`,
              `GRID_TOTAL_SHOW`,
            ],
          }),
        },
        {
          id: "13",
          name: "系统记录",
          target: "overview",
          to: "log",
          img: menupng.SysLog,
          icon: "changgui-jilu",
          show: Purview({
            action: [
              `EVENT_SHOW`,
              `PUSH_MESSAGE_SHOW`,
              `TELECOM_SHOW`,
              `LOG_SHOW`,
            ],
          }),
        },
        {
          id: "14",
          name: "推送策略",
          target: "overview",
          to: "pushstrategy",
          img: menupng.PushStrategy,
          icon: "changgui-dengpao1",
          show: Purview({ action: [`PUSH_STRATEGY_SHOW`] }),
        },
        {
          id: "15",
          name: "工单管理",
          target: "overview",
          to: "order",
          img: menupng.WorkRecordManage,
          icon: "changgui-gongdanguanli1",
          show: Purview({ action: [`ORDER_TASK_SHOW`] }),
        },
        {
          id: "16",
          name: "智能场景",
          target: "overview",
          to: "linkage",
          img: menupng.SmartScene,
          icon: "changgui-changjing",
          show: Purview({ action: [`LINKAGE_SHOW`] }),
        },
        {
          id: "17",
          name: "档案管理",
          target: "overview",
          to: "document",
          img: menupng.Document,
          icon: "changgui-danganjianying",
          show: true,
        },
        {
          id: "18",
          name: "巡检管理",
          target: "overview",
          to: "inspect",
          img: menupng.Inspect,
          icon: "changgui-xunjian",
          show: Purview({ action: [`INSPECT_TASK_SHOW`] }),
        },
        {
          id: "19",
          name: "系统报告",
          target: "overview",
          to: "systemReport",
          img: menupng.anquandaka,
          icon: "changgui-icon_daohang_daka",
          show: true,
        },
        {
          id: "20",
          name: "随手拍",
          target: "overview",
          to: "snapshot",
          img: menupng.screen,
          icon: "changgui-BIdaping",
          show: true,
        },
        {
          id: "11",
          name: "数字大屏",
          target: "_blank",
          to: "/screen",
          img: menupng.screen,
          icon: "changgui-BIdaping",
          show: false,
        },
      ];

      yield put({ type: "commonSuccess", payload: { menuList } });
    },
    *getUnitTree({ payload = {} }, { call, put }) {
      const { resolve, data } = payload;
      const ret = yield call(http.tokiot.sys.unit.tree, data || {});
      if (ret) {
        const units = JSON.parse(
          JSON.stringify(ret)
            .replace(/name/g, "title")
            .replace(/id/g, "value")
            .replace(/childrenList/g, "children")
        );
        resolve && resolve([units]);
      }
    },
    *getUnReadCount({ payload = {} }, { call, put }) {
      const { resolve, data } = payload;
      const unReadCount = yield call(
        http.tokiot.sys.pushLog.totalUnRead,
        data || {}
      );
      if (unReadCount) {
        yield put({ type: "commonSuccess", payload: { unReadCount } });
        resolve && resolve(unReadCount);
      }
    },

    *setRead({ payload }, { call, put }) {
      const { resolve, data } = payload;
      const type = data.type;
      delete data.type;
      const ret = yield call(http.tokiot.sys.pushLog.read, data || {});
      if (ret) {
        message.success(intl.get("message.global.setRead.success"));
        yield put({
          type: "getNotice",
          payload: { data: { type, readState: "UnRead" } },
        });
        resolve && resolve(ret);
      }
    },

    *setReadBatch({ payload }, { call, put }) {
      const { resolve, data } = payload;
      const ret = yield call(http.tokiot.sys.pushLog.readAll, data || {});
      if (ret) {
        message.success(intl.get("message.global.setReadBatch.success"));
        yield put({ type: "getNotice", payload: { data } });
        resolve && resolve(ret);
      }
    },
    *modifyPwd({ payload }, { call, put }) {
      const { data, resolve } = payload;
      const ret = yield call(http.tokiot.sys.user.changePassword, data || {});
      if (ret) {
        message.success(intl.get("message.global.modifyPwd.success"));
        resolve();
        yield LoginUnit.Logout();
      } else {
        // message.error(intl.get('message.global.modifyPwd.error'));
      }
    },
    *updateUser({ payload }, { call }) {
      const { data, resolve } = payload;
      const ret = yield call(http.tokiot.sys.user.updateHome, data || {});
      if (ret) {
        resolve && resolve();
      }
    },
    *getOrderDetail({ payload }, { put, call }) {
      const { data, resolve } = payload;
      const ret = yield call(http.tokiot.workOrder.detail, data || {});
      if (ret) {
        resolve && resolve(ret);
      }
    },
    *dealOrder({ payload }, { call }) {
      const { data, resolve } = payload;
      const ret = yield call(http.tokiot.workOrder.handle, data);
      if (ret) {
        message.success("处理成功");
        resolve && resolve(ret);
      }
    },
    *existMobile({ payload }, { call }) {
      const { data, resolve } = payload;
      const ret = yield call(http.tokiot.sys.user.existMobile, data);
      resolve(ret);
    },
    *existEmail({ payload }, { call }) {
      const { data, resolve } = payload;
      const ret = yield call(http.tokiot.sys.user.existEmail, data);
      resolve(ret);
    },
    *searchDevice({ payload }, { call, put }) {
      const { data, resolve } = payload;
      Object.keys(data).forEach((key) => {
        if (!data[key] || data[key] === "null" || data[key] === "undefined")
          delete data[key];
      });
      const pageData = yield call(http.tokiot.device.listMap, data || {});
      if (pageData) {
        resolve && resolve(pageData);
      }
    },
  },

  reducers: {
    getMenuSuccess(state, { payload }) {
      return {
        ...state,
        menu: payload,
        flatMenu: getFlatMenu(payload),
      };
    },
    commonSuccess(state, { payload }) {
      return { ...state, ...payload };
    },
  },
});

export function getFlatMenu(menus) {
  let menu = [];
  menus.forEach((item) => {
    if (item.children) {
      menu = menu.concat(getFlatMenu(item.children));
    }
    menu.push(item);
  });
  return menu;
}
